"use client";
import { memo, type ReactElement } from "react";
import { ColorType } from "@/theme/colors";
import { FontWeight } from "@/theme/typography";
import { Ctext } from "../Ctext";
import { CteamcardProviderIcons } from "./CteamcardProviderIcons";
import { CTEAMCARD_BOTTOM_ROW_STYLE } from "./Cteamcard.styles";
interface CteamcardFooterProps {
    llmVendors: string[];
    memberCount: number;
    isMobile: boolean;
    priority: boolean;
    useBackdropFilter: boolean;
}
export const CteamcardFooter = memo(function CteamcardFooter({ llmVendors, memberCount, isMobile, priority, useBackdropFilter, }: CteamcardFooterProps): ReactElement {
    return <div style={CTEAMCARD_BOTTOM_ROW_STYLE}>
            <CteamcardProviderIcons isMobile={isMobile} priority={priority} useBackdropFilter={useBackdropFilter} vendors={llmVendors}/>
            <Ctext size={18} color={ColorType.Accent} weight={FontWeight.Bold} opacity={1} style={{ whiteSpace: "nowrap" }}>
                {memberCount} Members
            </Ctext>
        </div>
        ;
});
